import { render } from "./AgentDashboardView.vue?vue&type=template&id=bad17bee&scoped=true"
import script from "./AgentDashboardView.vue?vue&type=script&lang=js"
export * from "./AgentDashboardView.vue?vue&type=script&lang=js"

import "./AgentDashboardView.vue?vue&type=style&index=0&id=bad17bee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad17bee"]])

export default __exports__